const autocomplete = (options) => ({

    query: '',
    items: [],
    selected: null,

    init() {
        this.$watch('selected', () => {
            this.$dispatch('ac-item-selected', this.selected);
        });
    },

    displayKey: (item) => item['place'],
    getKey(item) {
        return item['place'];
    },

    onChange(e) {
        this.query = e.target.value;

        if (this.query.length > 0) {
            this.search();
        }
    },

    search() {
        fetch(`${options.serviceUrl}/api/addresses/suggest?query=${this.query}`, {
            headers: {
                'Content-Type': 'application/json',
                'Accept': 'application/json',
                'ApiKey': options.apiKey
            }
        })
            .then((response) => { return response.json(); })
            .then((data) => {
                this.items = data;
            });
    }

});

export { autocomplete };